import { createMixpanelStore } from "~/lib/analytics/mixpanel";
import { createStatsigStore } from "~/lib/analytics/statsig";
import { createGenerateActorStore } from "~/modules/actors/stores/generate-actor-store";
import { createAudioCreationStore } from "~/modules/project/stores/audio-creation";
import { createAudioPermissionsStore } from "~/modules/project/stores/audio-permissions";
import { createAudioRecordingStore } from "~/modules/project/stores/audio-recording";
import { createClipSequenceSelectorStore } from "~/modules/project/stores/clip-sequence-selector";

import { createEventStreamStore } from "../lib/analytics/track";
import { createAuthStore } from "../modules/auth/auth-store";

import { createConfigStore } from "./config";
import { createIntercomStore } from "./intercom";
import { createLayoutStore } from "./layout";
import { createMocksStore } from "./mocks";
import { registerStore } from "./root";

export function registerPrimaryStores() {
  registerStore("config", createConfigStore);
  registerStore("event-stream", createEventStreamStore);
  registerStore("auth", createAuthStore);
  registerStore("mocks", createMocksStore);
  registerStore("mixpanel", createMixpanelStore);
  registerStore("statsig", createStatsigStore);
  registerStore("layout", createLayoutStore);
  registerStore("intercom", createIntercomStore);

  registerStore("audio-creation", createAudioCreationStore);
  registerStore("audio-permissions", createAudioPermissionsStore);
  registerStore("audio-recording", createAudioRecordingStore);
  registerStore("clip-sequence", createClipSequenceSelectorStore);
  registerStore("generate-actor", createGenerateActorStore);
}
